import React from 'react'
import classes from './styles.module.scss';
import Card from '../../../../components/card/card.component';
import { useTranslation } from 'react-i18next';
import { useKato } from '../../../../contexts/kato.context';
import { ICardName, ITotalRoadShareStats } from '../../../../types/kato.types';
import { RoadSubTypeToIcon } from '../../../../consts/other.conts';
import { useNavigate, useParams } from 'react-router-dom';
import { useShared } from '../../../../contexts/shared.context';

const baseClass = 'road-card';
const translationKey = 'cards.road-card';

const keys: (keyof ITotalRoadShareStats)[] = ['curYearTotalFineRoadPercentage', 'totalCurYearGoodConditionPercentage', 'totalCurYearSatisfactoryConditionPercentage', 'totalCurYearPoorConditionPercentage'];

const RoadCard = () => {
    const { t } = useTranslation();
    const { totalRoadShareStats } = useKato().katoGeneralInfo;
    const { setFullscreen } = useShared();
    const { kato, link, tab } = useParams<{ kato: string; link: string; tab: string }>();
    const navigate = useNavigate();

    const onClick = () => {
        setFullscreen({ open: true, type: ICardName.ROAD });
        navigate(`/${kato}/${link}/${tab}/${ICardName.ROAD}`);
    }


    if (!totalRoadShareStats) return null;

    return (
        <Card
            title={t(`${translationKey}.title`)}
            subtitle={t(`${translationKey}.subtitle`, { year: new Date().getFullYear() - 1 })}
            onClick={onClick}
        >
            <div className={classes[baseClass]}>
                {
                    keys.map(key => (
                        <div key={key} className={classes[`${baseClass}__item`]}>
                            <span className={classes[`${baseClass}__icon`]}>
                                {RoadSubTypeToIcon[key]}
                            </span>
                            <span className={classes[`${baseClass}__label`]}>{t(`${translationKey}.${key}`)}</span>
                            <span className={classes[`${baseClass}__value`]}>
                                {totalRoadShareStats[key] ? `${totalRoadShareStats[key]}%` : '-'}
                            </span>
                        </div>
                    ))
                }
            </div>
        </Card>
    )
}

export default RoadCard